<template>
  <div>
    <div class="text-center">
      <span class="titel">{{ translation(4901) }}</span>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p class="text-center">
          <span>{{ translation(4902) }}</span>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 form-box">
        <fieldset class="featured-fieldset">
          <div class="row margin20">
            <div class="col-md-12 from-group has-feedback">
              <div :class="{ 'has-error': errors.has('ddlBeroepsgroep') }">
                <XVdropdown
                  id="ddlBeroepsgroep"
                  name="ddlBeroepsgroep"
                  :placeholder="translation(15593)"
                  :data-vv-as="translation(15593)"
                  v-validate="'required'"
                  :datalist="forminputdata.profGroups"
                  v-model="forminputdata.selectedProfGroup"
                  @input="setselectedProfGroup"
                ></XVdropdown>
                <span style="color: red" v-show="errors.has('ddlBeroepsgroep')">
                  {{ errors.first('ddlBeroepsgroep') }}
                </span>
              </div>
            </div>
          </div>
          <div class="row margin20">
            <div class="col-md-12">
              <button class="btn btn-primary btn-block" @click="accountAanvragen">{{ translation(4905) }}</button>
            </div>
          </div>
          <div class="row margin20 margin20bottom">
            <div class="col-md-12 text-center">
              <a href="#" v-html="translation(15594)" @click="inloggen" class="pointer"></a>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="row margin20">
      <div class="col-md-12">
        <XVbrowserFooter></XVbrowserFooter>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { sync } from 'vuex-pathify'

export default {
  computed: {
    forminputdata: sync('SPE610ExtOrgSelection/forminputdata'),
  },
  mounted() {
    this.getTexten()
    this.initProfGroups({
      orgID: Number.parseInt(this.$route.query.orgID, 10) || null,
      profgroupID: Number.parseInt(this.$route.params.profgroupID, 10) || null,
    })
  },
  methods: {
    ...mapActions('SPE610ExtOrgSelection', ['initProfGroups', 'getloginUrl', 'getTexten']),
    ...mapMutations('SPE610ExtOrgSelection', ['setselectedProfGroup']),
    ...mapMutations(['addNotification']),
    accountAanvragen() {
      this.$validator.validate().then((result) => {
        if (result) {
          // hier wordt geen routerlink gebruikt ivm met de reload van de pagina zodat de CSS geladen wordt.
          window.location = '/peapp/public/SPE620ExtOrgAccountAanvragen/' + this.forminputdata.selectedProfGroup
        } else {
          this.addNotification({
            groupname: 'warning',
            message: this.translation(14642),
          })
        }
      })
    },
    inloggen() {
      this.$validator.validate().then(async (result) => {
        if (result) {
          let profgroupid = {
            SES_bergrpid: this.forminputdata.selectedProfGroup,
          }
          await this.getloginUrl(profgroupid)
          window.location = this.forminputdata.loginUrl
        } else {
          this.addNotification({
            groupname: 'warning',
            message: this.translation(14642),
          })
        }
      })
    },
  },
}
</script>
